/** @format */

import React from "react";
import logo from "../../assets/logo.svg";

export const Logo = () => {
  return (
    <div className="flex items-center cursor-pointer">
      <img src={logo} alt="logo" className="lg:-ml-2 ml-3" />
      <h1 className="text-[25px] font-bold leading-[34.1px] text-white -ml-2">
        Fit<span className="text-[#0CC6D3]">Stats</span>
      </h1>
    </div>
  );
};
